import { Optional, Pipe, PipeTransform } from '@angular/core';
import { TimeFormat } from '../../auth/models/mmu-user-preferences';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import moment from 'moment';

@Pipe({
  name: 'formatTime'
})
export class MmuFormatTimePipe implements PipeTransform {
  private readonly preferredFormat: TimeFormat;

  constructor(@Optional() private userService: MmuUserService) {
    this.preferredFormat = this.userService?.user?.prefs?.timeFormat ?? TimeFormat.H24;
  }

  transform(value: Date | string | number, format?: TimeFormat): string | null {
    if (!value) {
      return null;
    }

    format = format ?? this.preferredFormat;

    const formatStr = format === TimeFormat.H24 ? 'HH:mm' : 'hh:mm A';
    const date = moment(new Date(value));
    return date.isValid() ? date.format(formatStr) : null;
  }
}
